import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import relay_pm_app_settings from '@devices/settings/device_settings/app_settings_pm_gen_1.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shelly1l',
	friendly_name: '1L',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'forgotten_lights',
				'overtemperature',
			],
			control_holder: 0,
			settings: [
				timer,
				schedule,
				actions,
				internet,
				relay_pm_app_settings,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default_1l' },
						{
							title: 'button_type_index',
							values: { index: 1 },
							component: 'button_type_1l',
						},
						{
							title: 'button_type_index',
							values: { index: 2 },
							component: 'button_type_1l2',
						},
						{ title: 'long_push', component: 'long_push' },
						{ title: 'power_consumption', component: 'power_consumption' },
						{ title: 'swap_inputs', component: 'swap_inputs_1l' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: [
				'ext_hum_over_url',
				'ext_hum_under_url',
				'ext_temp_over_url',
				'ext_temp_under_url',
			],
		},
	},
};
